import { render, staticRenderFns } from "./profile-view-assignments.vue?vue&type=template&id=c392b736&"
import script from "./profile-view-assignments.vue?vue&type=script&lang=js&"
export * from "./profile-view-assignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports